import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index'
import introduce from '@/view/introduce'
import info from '@/view/info'
import results from '@/view/results'

Vue.use(Router);

export default new Router ({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/introduce',
      name: 'introduce',
      component: introduce
    },
    {
      path: '/info',
      name: 'info',
      component: info
    },
    {
      path: '/results',
      name: 'results',
      component: results
    }
  ]
})